export default "__VITE_ASSET__BOMZqKIR__"